import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomPaginator extends MatPaginatorIntl {
	itemsPerPageLabel = 'Listing per Page';

	getRangeLabel = function (page, pageSize, length) {
		if (length === 0 || pageSize === 0) {
			return 'Show 0';
		}

		length = Math.max(length, 0);

		const startIndex = page * pageSize;
		const endIndex =
			startIndex < length
				? Math.min(startIndex + pageSize, length)
				: startIndex + pageSize;
		const sumStartIndex = startIndex + 1;

		return 'Show ' + sumStartIndex + ' - ' + endIndex;
	};
}
